export default class RegionSerializer {
  static serialize(data) {
    return {
      regionId: data.regionId,
      regionName: data.regionName,
      dateCreated: data.dateCreated,
      dateModified: data.dateModified,
      mapURL: data.mapURL
    };
  }

  static deSerialize(data) {
    return {
      regionId: data.regionId,
      regionName: data.regionName,
      dateCreated: data.dateCreated,
      dateModified: data.dateModified,
      mapURL: data.mapURL
    };
  }
}